import ActionButton from "controls/global/action-button/ActionButton";
// import { useConfigurationProvider } from "pages/signatures/providers/manage-signature/ConfigurationProvider";
import {  useSignatureProvider } from "pages/signatures/providers/manage-signature/SignatureProvider";
import {
  StepKeys,
  // useWizardProvider,
} from "pages/signatures/providers/manage-signature/WizardProvider";
import React from "react";

type Props = {
  activeStep: StepKeys;
};

export default function BackButton({ activeStep }: Props) {
  // const { dispatch: configurationDispatch } = useConfigurationProvider();
  // const { dispatch: wizardDispatch } = useWizardProvider();
  // const { dispatch: signatureDispatch } = useSignatureDispatchProvider();
  const {
    state: { signature },
  } = useSignatureProvider();
  // const [icon, setIcon] = useState<ReactNode>(<ClearIcon />);
  const onBackToConfiguration = signature.onBackToConfiguration;
  const handleBack = () => {
    // if (activeStep === "MENU") {
    //   configurationDispatch({ type: "RESET" });
    //   signatureDispatch({ type: "CLOSE" });
    //   wizardDispatch({ type: "RESET" });
    // }
    // else {
    //   // wizardDispatch({ type: "BACK" });
    // }
    if (onBackToConfiguration) {
      onBackToConfiguration();
    }
  };

  return (
    <ActionButton
      variant="outlined"
      color="secondary"
      onClick={handleBack}
    // startIcon={icon}
    >
      {"Back"}
    </ActionButton>
  );
}
